export default __webpack_public_path__ + "static/media/esculturas nandasmo1.3df505e2.jpg";